import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

const OptionalTooltip = ({ title, children, ...tooltipProps }) => {
  if (!title) {
    return children;
  }

  return (
    <Tooltip title={title} {...tooltipProps}>
      {children}
    </Tooltip>
  );
};

export default OptionalTooltip;
